import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "available",
  "use": "available-usage",
  "viewBox": "0 -2 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 -2 16 17\" id=\"available\"><rect width=\"12\" height=\"12\" x=\"1\" y=\"1\" stroke=\"#fff\" stroke-width=\"2\" rx=\"6\" /><rect width=\"10\" height=\"10\" x=\"2\" y=\"2\" fill=\"#5CD498\" rx=\"5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol